import React from 'react';
import { FormattedMessage } from 'react-intl';

const InfoList = ({ items }: { items: string[] }) => (
  <ul className="home-page__info-list">
    {items.map((id) => (
      <li key={id}>
        <FormattedMessage id={id} />
      </li>
    ))}
  </ul>
);

export default InfoList;
